import { createContext, useContext } from 'react';

/**
 * Stable context — static config and callbacks only.
 * Dynamic state lives in dedicated Zustand stores:
 *  - useSelectionStore     — selected tile IDs
 *  - useOccupiedStore      — occupied/pending entries (polled every 5 s)
 *  - useKeyboardFocusStore — keyboard focus state
 *
 * Shape:
 *   fieldType         {string}   - Field type slug (e.g. 'normal')
 *   mode              {string}   - 'interactive' | 'preview'
 *   fieldConfig       {Object}   - Full field configuration from the JSON / REST API
 *   grid              {Object}   - Full buildGrid() result (totalWidth/Height, cols, rows, tiles, normalizedBundles, …)
 *   tiles             {Array}    - Shortcut: grid.tiles (resolved tile array)
 *   normalizedBundles {Array}    - Shortcut: grid.normalizedBundles
 *   toggleTile        {Function}
 *   clearSelection    {Function}
 *   isLoading         {boolean}
 */
export const PitchFieldContext = createContext( null );

export function usePitchField() {
	const ctx = useContext( PitchFieldContext );
	if ( ! ctx ) throw new Error( 'usePitchField must be used inside a <PitchField> component.' );
	return ctx;
}
